export function init(file: URL) {
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search);
  if (urlParams.has('mdt') && urlParams.get('mdt') === '1') {
    import(file.href);
  }
}
